import { forwardRef } from 'react';

import { useTranslation } from '@/hooks/useTranslation';

/**
 * "History" of the detail page (wireframe `7170:95515`). The API does not record asset
 * history yet, so the section shows its empty state until LAX-10529 (D-043).
 */
const DamAssetHistoryPanel = forwardRef<HTMLElement>((_, ref) => {
    const { t } = useTranslation();

    return (
        <section ref={ref} tabIndex={-1} className="tw-flex tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-tertiary tw-bg-fill-primary tw-p-4 md:tw-p-6">
            <h2 className="tw-m-0 tw-text-t-base tw-font-bold tw-text-t-primary lg:tw-text-t-lg">{t('DAM.DETAIL.HISTORY')}</h2>
            <p className="tw-m-0 tw-rounded-lg tw-border tw-border-solid tw-border-tertiary tw-px-4 tw-py-3 tw-text-t-sm tw-text-t-secondary lg:tw-text-t-base">
                {t('DAM.DETAIL.NO_HISTORY')}
            </p>
        </section>
    );
});

DamAssetHistoryPanel.displayName = 'DamAssetHistoryPanel';

export { DamAssetHistoryPanel };
